import axios from 'axios'
import {
  QualificationApplicationRequest,
  Resources, ContractType,
} from '@hankintailmoitukset.fi/hilma-espd-edm'
import ValidationState from '@/enums/validationState'

export class EspdRequest {
  id: number

  title: string

  uUID: string

  projectId: number

  noticeId: number

  procedureId: number

  eNoticeId: number

  noticeType: string

  contractType: ContractType

  hilmaTendering: boolean

  qualificationApplicationRequest: QualificationApplicationRequest

  language: string

  lots: string[]

  validationState: ValidationState
}

// Fetch list of all criteria
export function getEspdCriteria() {
  return Resources.criterionSpecification
}

export async function saveEspdRequest(identifier: number, host: string, payload: EspdRequest) {
  const url = `${host}api/requests/${identifier}`
  await axios.put(url, payload)
}

// Fetch the ESPD request from the server by id
export async function getEspdRequest(identifier: number, host: string) {
  const url = `${host}api/requests/${identifier}`
  try {
    const returned = await axios.get(url)
    return returned.data as EspdRequest
  } catch (error) {
    return undefined
  }
}
